import React from 'react';
import { useClinicalDemo } from '../../contexts/ClinicalDemoContext';
import { DemoSectionHeader } from '../demoShell/DemoSectionHeader';
import { HistoryControls } from '../demoShell/HistoryControls';
import { downloadJson, formatTimestamp } from '../../utils/demoStorage';
import { clinicalExport } from '../../utils/clinicalDemo';
export function ClinicalHistory() {
  const {
    state,
    reset
  } = useClinicalDemo();
  return <div data-id="element-102" data-mp="vgkaommg284o">
      <DemoSectionHeader title="History & Controls" description="Record history for this fictional patient, newest first." data-id="element-103" data-mp="vgaicsdxfovt" />
      <div className="grid grid-cols-1 gap-8 xl:grid-cols-[minmax(0,7fr)_minmax(0,4fr)]" data-id="element-104" data-mp="rcck0jwfei3t">
        <ol className="divide-y divide-line border-y border-line" data-id="element-105" data-mp="157nbdnbgol3f">
          {state.history.map(event => <li key={event.id} className="py-3" data-id="element-106" data-mp="10d0wvba32cf4">
              <p className="text-xs text-ink-muted" data-id="element-107" data-mp="co81bfxdi6l1">
                <span className="font-mono" data-id="element-108" data-mp="7q6h2ro7o17z">{event.id}</span> · {formatTimestamp(event.at)}
              </p>
              <p className="mt-0.5 text-ink-dark" data-id="element-109" data-mp="398ujj4l93bg5">{event.action}</p>
            </li>)}
        </ol>
        <div className="xl:sticky xl:top-28 xl:self-start" data-id="element-110" data-mp="3e7e4b1o3yh6x">
          <HistoryControls domainName="Clinical" exportLabel="Export clinical records" onExport={() => downloadJson('noetivra-clinical-records.json', clinicalExport(state))} onReset={reset} data-id="element-111" data-mp="3e5ky1nhepyzg" />
        </div>
      </div>
    </div>;
}